import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import EmptyState from 'modules/approvals/components/ApprovalsInformationBlock/EmptyState'
import MaterializedApprovalFlowUtils from 'modules/approvals/lib/MaterializedApprovalFlowUtils'

import BasicInformationApproval from '../../BasicInformationApproval'
import type { ApprovalData } from '../types'

interface Props {
  collapseContentData: ApprovalData
  blocks?: {
    rightBlock?: React.ReactNode
    leftBlock?: React.ReactNode
  } | null
}

const CollapseContent = ({ collapseContentData, blocks }: Props) => {
  if (!collapseContentData.approvalFlow) {
    return (
      <EmptyState
        hideBorder
        title={i18n.t(
          'settings.approvals.approval_request_view.approval_history.no_permission.title'
        )}
        description={i18n.t(
          'settings.approvals.approval_request_view.approval_history.no_permission.description'
        )}
      />
    )
  }

  return (
    <Box flexDirection="row" gap="s40">
      {!collapseContentData?.hideBasicInformation && (
        <BasicInformationApproval collapseContentData={collapseContentData} />
      )}

      {blocks?.rightBlock ? (
        blocks?.rightBlock
      ) : (
        <Box width="full" gap="s24">
          {MaterializedApprovalFlowUtils.emailBlocks(collapseContentData.approvalFlow).map(
            (block, index) => {
              const value = block?.value == null ? '' : String(block?.value)

              return (
                <Box key={index}>
                  <TextField
                    readonly
                    label={block?.key_label}
                    value={Date.parse(value) ? dateBackendDateTimeToUI(value) : value}
                  />
                </Box>
              )
            }
          )}
        </Box>
      )}
    </Box>
  )
}

export default CollapseContent
